
<iframe  height="100%" width="100%" [src]="pdfSrc"></iframe>